import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "agent-form"
}
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Povinsi", -1)
const _hoisted_4 = { class: "invalid-feedback" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Kota / Kabupaten", -1)
const _hoisted_7 = { class: "invalid-feedback" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Kode Kota ", -1)
const _hoisted_10 = { class: "invalid-feedback" }
const _hoisted_11 = { class: "container-btn-action" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Simpan")

import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
import { Form, Field } from 'vee-validate'
import vSelect from 'vue-select'
import * as Yup from 'yup'
import { useStore } from 'vuex'
import InputSwitch from 'primevue/inputswitch'
import { onMounted, getCurrentInstance, ref, computed, onBeforeUnmount } from 'vue'
import { IBankForm } from '@/utils/interfaces/iBank'
import apiUseCase from '@/usecase/apiUseCase'
import { isNull, upperCase } from 'lodash'
import rgxExp from '@/utils/helpers/regExp'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import SelectFetch from '@/views/components/form/SelectAsync.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CityForm',
  setup(__props) {

const moduleStore = 'hjpTable'
const endpoint = '/management/v2/Cities'
const store = useStore()
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const dataForm = ref()
const idPrams = computed(() => store.state[moduleStore].modal?.data?.Id)
const isLoading = ref(true)

const initialValues = {
  Name: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.Name : '',
  Code: '',
  Province: null,
  // IsActive: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.IsActive : true
}

const schema = Yup.object().shape({
  Name: Yup.string()
    .max(50, 'Nama Kota/Kabupaten tidak boleh melebihi 50 karakter')
    .matches(rgxExp.notPrefixSpace, 'Nama Kota/Kabupaten tidak boleh hanya menggunakan spasi')
    .required('Nama Kota/Kabupaten harus diisi')
    .test('unique-name', 'Nama Kota/Kabupaten sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['q']
        })}`)
        const filterResult = res.result.filter((x: any) => x.Name === val)
        if (idPrams.value) {
          return filterResult.length === 0 || val === initialValues.Name
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  Code: Yup.string()
    .max(50, 'Kode Kota/Kabupaten tidak boleh melebihi 50 karakter')
    .matches(rgxExp.notPrefixSpace, 'Kode Kota/Kabupaten tidak boleh hanya menggunakan spasi')
    .required('Kode Kota/Kabupaten harus diisi')
    .test('unique-name', 'Kode Kota/Kabupaten sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val.toUpperCase(),
          filterField: ['q']
        })}`)
        const filterResult = res.result.filter((x: any) => x.Name === val)
        if (idPrams.value) {
          return filterResult.length === 0 || val === initialValues.Name
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  Province: Yup.object().typeError('Provinsi harus diisi').required('Provinsi harus diisi'),
})

const onSubmit = (values: any) => {
  console.log('masukk submit', values)
  // eslint-disable-next-line no-use-before-define
  processSubmit(values)
}

const hideSidebar = () => {
  // store.dispatch('setShowModal', false)
  store.dispatch('setShowModalFormDl', false)
  store.dispatch('setTitleFormSidebar', null)
}

const changeOk = (val: any) => {
  console.log('valll', val)
}

const onSearchOption = (search: any, loading: any) => {
  console.log('search', search)
}

const onSelectedBank = (selected: any) => {
  console.log('selected', selected)
}

const processSubmit = async (val: any) => {
  store.dispatch('showLoading')
  console.log('val', val)

  if (isNull(store.state.hjpDataList.modalForm.data)) {
    dataForm.value = {
      Name: val.Name,
      CityCode: val.Code.toUpperCase(),
      CityName: val.Name.toUpperCase(),
      IslandId: null,
      MsProvinceId: val.Province.Id,
      CityGroupIntId: null,
      // IsActive: val.IsActive,
    }
  } else {
    dataForm.value = {
      Id: store.state.hjpDataList.modalForm.data ? store.state.hjpDataList.modalForm.data.Id : '',
      Name: val.Name,
      CityCode: val.Code.toUpperCase(),
      CityName: val.Name.toUpperCase(),
      IslandId: null,
      MsProvinceId: val.Province.Id,
      CityGroupIntId: null,
      // IsActive: val.IsActive,
    }
  }
  const response = isNull(store.state.hjpDataList.modalForm.data) ? await apiUseCase.postOrPut(endpoint, null, dataForm.value) : await apiUseCase.postOrPut(endpoint, store.state.hjpDataList.modalForm.data.Id, dataForm.value)
  if (!response.error) {
    $toast.add({
      severity: 'success',
      detail: isNull(store.state.hjpDataList.modalForm.data) ? 'Data Berhasil Ditambahkan' : 'Data Berhasil Diubah',
      group: 'bc',
      closable: false,
      life: 3000
    })
  } else {
    $toast.add({
      severity: 'error',
      detail: isNull(store.state.hjpDataList.modalForm.data) ? 'Data Gagal Ditambahkan' : 'Data Gagal Diubah',
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
  store.dispatch('setShowModalFormDl', false)
  store.dispatch('setReloadDataList', true)
  store.dispatch('setTitleFormSidebar', null)
  store.dispatch('hideLoading')
}

const getDataCity = async () => {
  store.dispatch('showLoading')
  const id = store.state.hjpDataList.modalForm.data.Id
  const response = await apiUseCase.get(`${endpoint}/${id}`)
  if (response.error) {
    $toast.add({
      severity: 'error',
      detail: 'Gagal Mengambil Data. Silahkan Coba Lagi',
      group: 'bc',
      closable: false,
      life: 3000
    })
    hideSidebar()
  } else {
    const res = response.result
    initialValues.Code = res.CityCode
    initialValues.Name = res.CityName
    initialValues.Province = {
      ...res.MsProvince,
      label: res.MsProvince ? `${res.MsProvince.ProvinceCode} - ${res.MsProvince.ProvinceName}` : null,
      value: res.MsProvince ? res.MsProvince.Id : null
    }
    console.log('res', response.result)
  }
  isLoading.value = false
  store.dispatch('hideLoading')
}

onMounted(() => {
  console.log('store', store.state)
  let titleForm = 'Tambah'
  if (store.state.hjpDataList.modalForm.data) {
    titleForm = 'Edit'
    getDataCity()
  } else {
    isLoading.value = false
  }
  store.dispatch('setTitleFormSidebar', `${titleForm} Kota`)
})

onBeforeUnmount(() => {
  store.dispatch('storeRowDataListDl', null)
})


return (_ctx: any,_cache: any) => {
  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(Form), {
          onSubmit: onSubmit,
          "validation-schema": _unref(schema),
          "initial-values": initialValues,
          class: "form-container"
        }, {
          default: _withCtx(({ errors, setFieldValue, values }) => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_unref(Field), { name: "Province" }, {
                default: _withCtx(({ field }) => [
                  _createVNode(SelectFetch, _mergeProps(field, {
                    placeholder: 'Pilih Provinsi',
                    modelValue: field.value,
                    id: 'province',
                    inputId: 'province',
                    endpoint: "/management/v1/MsProvince",
                    classname: 'custom-select',
                    searchCustom: [['activeOnly', '=', true]],
                    fieldLabel: (v) => `${v.ProvinceCode} - ${v.ProvinceName}`,
                    clearable: false,
                    searchFields: ['query']
                  }), null, 16, ["modelValue", "fieldLabel"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_4, _toDisplayString(errors.Province), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_unref(Field), { name: "Name" }, {
                default: _withCtx(({ field, handleChange, handleBlur }) => [
                  _createVNode(_unref(InputText), _mergeProps(field, {
                    modelValue: values.Name,
                    "onUpdate:modelValue": ($event: any) => ((values.Name) = $event),
                    onChange: handleChange,
                    onBlur: handleBlur,
                    class: `input-primary ${errors.Name ? 'input-invalid' : ''}`,
                    placeholder: "Tulis Nama Kota/Kabupaten",
                    autocomplete: "off",
                    maxlength: 50,
                    style: 'text-transform:uppercase'
                  }), null, 16, ["modelValue", "onUpdate:modelValue", "onChange", "onBlur", "class"])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_7, _toDisplayString(errors.Name), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_unref(Field), { name: "Code" }, {
                default: _withCtx(({ field, handleChange, handleBlur }) => [
                  _createVNode(_unref(InputText), _mergeProps(field, {
                    modelValue: values.Code,
                    "onUpdate:modelValue": ($event: any) => ((values.Code) = $event),
                    onChange: handleChange,
                    onBlur: handleBlur,
                    class: `input-primary ${errors.Name ? 'input-invalid' : ''}`,
                    placeholder: "Tulis Kode Kota",
                    autocomplete: "off",
                    maxlength: 50,
                    style: 'text-transform:uppercase'
                  }), null, 16, ["modelValue", "onUpdate:modelValue", "onChange", "onBlur", "class"])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_10, _toDisplayString(errors.Code), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(Button), {
                class: "btn-back mr-2",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (hideSidebar()))
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }),
              _createVNode(_unref(Button), {
                type: "submit",
                class: "btn-primary mr-1"
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["validation-schema"])
      ]))
    : _createCommentVNode("", true)
}
}

})